<template>
	<div class="serviceBox">
		<div class="fixed">
			<ul class="list" :style="{width:212 * case_list.length +'px'}">
				<li v-for='(item,index) in case_list' :key=index  @click="tocase(item.id)">
					<img :src="item.icon">
					<template v-if="languageIndex == 0">
						<h3>{{item.name}}
              <small v-if="item.id == 600 && $route.name == 'mainPaseCmdcenter'">({{num}})</small>
              <small v-else>({{num_list[item.id] || 0}})</small>
            </h3>
						<p>{{item.descrition}}</p>
					</template>
					<template v-if="languageIndex == 1">
						<h3 style="font-size: 14px;">{{item.nameEn}}<small v-if="num_list[item.id] != 0">({{num_list[item.id]}})</small></h3>
						<p>{{item.descritionEn}}</p>
					</template>
					<div class="manage" :class="languageIndex == '1' ? 'enlange':''">
						<p>{{langtrans().ajgl[languageIndex]}}</p>
						<div class="arrow"></div>
					</div>
				</li>
			</ul>
		</div>
		<div class="zixun" @mouseover="zixunShow=false" @mouseout="zixunShow=true" v-if="this.$route.name == 'mainPaseCmdcenter'" @click="routerGo">
			<p>{{langtrans().zxlajg[languageIndex]}}</p>
			<img class="img1" src="./img/weixuanzhong.png" v-show="zixunShow">
			<img class="img2"  src="./img/active.png" v-show="!zixunShow">
		</div>
	</div>
  <!-- <div style="min-height: 320px;">
    <div>
      <h1 style="display: inline-block;">案件创建及查询</h1>
      <div style="width:120px;height:26px;border: 1px solid #D9D9D9;border-radius: 4px;display: inline-block;position: absolute;top: 4px;left: 200px;">
        <div @click="actClick(1)" class="tab" :class="{ act1: actmodel == 1}">全部</div>
        <div @click="actClick(2)" class="tab" :class="{ act2: actmodel == 2}">待处理</div>
      </div>
    </div>
   
     <ul style="margin-left: -55px;">
      <li class="Newli" v-for='(item,index) in case_list' :key=index  @click="tocase(item.id)">
        <div v-if="item.id == 600 && $route.name == 'mainPaseCmdcenter'">
          <img v-if="num != 0" style="position: absolute;left: 27px;top: 20px;" src="./img/red.png">
          <img v-else style="position: absolute;left: 27px;top: 20px;" src="./img/blue.png">
        </div>
         <div v-else>
          <img v-if="num_list[item.id] || 0 != 0" style="position: absolute;left: 27px;top: 20px;" src="./img/red.png">
          <img v-else style="position: absolute;left: 27px;top: 20px;" src="./img/blue.png">
         </div>
         <div style="width:80%;height: 100%;float: right;">
          <div style="font-size: 21px;height: 50%;line-height: 62px;">
            {{item.name}}
          </div>
          <div style="font-size: 14px;height: 50%;line-height: 28px;">
            <small v-if="item.id == 600 && $route.name == 'mainPaseCmdcenter'">待处理：({{num}})</small>
            <small v-else>待处理：({{num_list[item.id] || 0}})</small>
          </div>
         
         </div>
        </li>
       <li class="Newli"  @click="more()">{{moreName}}</li>   
     </ul>
  </div> -->
</template>

<script>
  import { caseCountNum,seversList } from '@/views/axios/api.js';
	export default{
    props:[
			'case_list',
			'num_list',
			'routePath'
		],
		data(){
			return {
        // case_list:[],
        moreName:'点击收起',
        actmodel:1,
				insti:JSON.parse(window.localStorage.getItem("insti")),//头部数据
				token:JSON.parse(window.localStorage.getItem("data")).data,
				zixunShow:true,
        num:''
			}
		},
 
    mounted(){
      console.log(JSON.parse(window.localStorage.getItem("usertype")).data);
      if(this.$route.name == 'mainPaseCmdcenter'){
        this.getXsNum()
      }
      // this.getSeverFun()
      // this.more()
    },
    created() {
      
    },
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		destroyed () {},
		methods:{
      more() {
       
     
        if(this.moreName == '点击查看更多') {
         
          this.moreName = '点击收起'
          if(this.actmodel == 1) {
            this.getSeverFun()
            }else {
              var data={
              token:JSON.parse(window.localStorage.getItem("data")).data,
                parentId:0					
              }
              seversList(data)
              .then(res=>{
              this.case_list =  res.data.obj
              for(var i = 0; i<this.case_list.length; i++) {
                  console.log(this.num_list[this.case_list[i].id])
                  if(this.num_list[this.case_list[i].id] == 0) {
                    this.deletelast(this.case_list,i)
                  }
              }
              })
              .catch(err=>{
                console.log(err)
              })
             
              
            }
        }else {
          this.moreName = '点击查看更多'
          if(this.actmodel == 1) {
            var data={
              token:JSON.parse(window.localStorage.getItem("data")).data,
                parentId:0					
              }
              seversList(data)
              .then(res=>{
                for(var i = 0; i<res.data.obj.length; i++) {
                  console.log(this.num_list[res.data.obj[i].id])
                  if(this.num_list[res.data.obj[i].id] == 0) {
                    this.deletelast2(this.deletelast(res.data.obj,i),1) 
                  }
              } 
              this.case_list =  this.deletelast2(res.data.obj,1)
              })
              .catch(err=>{
                console.log(err)
              })
            }else {
              this.case_list = this.deletelast2(this.case_list,1) 
              
            }
        
        }
        console.log(this.case_list)
      },
      getSeverFun(){//获取分类
				var data={
			   token:JSON.parse(window.localStorage.getItem("data")).data,
					parentId:0					
				}
				seversList(data)
				.then(res=>{
            this.case_list = res.data.obj
				})
				.catch(err=>{
					console.log(err)
				})
			},
      deletelast(arr,i){
        console.log(arr,i)
        return arr.splice(i,1);
     },
      deletelast2(arr){
        console.log(arr)
        return arr.splice(0,2);
     },
      actClick(type) {
        this.actmodel = type
       if(type == 1) {
        if(this.moreName != '点击查看更多') {
          this.getSeverFun()
        }else {
          var data={
              token:JSON.parse(window.localStorage.getItem("data")).data,
                parentId:0					
              }
              seversList(data)
              .then(res=>{
                this.case_list =  this.deletelast2(res.data.obj,1)
              })
              .catch(err=>{
                console.log(err)
              })
        }
     
       }else {
        if(this.moreName != '点击查看更多') {
          // this.getSeverFun()
          for(var i = 0; i<this.case_list.length; i++) {
             console.log(this.num_list[this.case_list[i].id])
             if(this.num_list[this.case_list[i].id] == 0) {
              this.deletelast2(this.deletelast(this.case_list,i),1)
             }
        }
        }else {
         
        }
        // this.more()
       
        
       }
       
      },
      getXsNum(){
      
        var data1='status=200&status=210&status=211&status=230'
        var data={
          token:this.token,
          typeId:600
        }
        caseCountNum(data,data1)
        .then(res => {
          console.log(res);
          this.num=res.data.obj
        })
        .catch(err => {
          console.log(err);
        })
      
      },
			langtrans(){
				return langtrans
			},
			routerGo(){
				this.$router.push({
					path:'/creatNav/consultingCase',
					query:{caseType:1,status:1}
				})
			},
			tocase(id) {
				console.log(id)
        console.log(this.insti)
				let token = this.token;
				let insti = this.insti;
				let name = "";
				this.case_list.map(v => {
					if(v.id == id) {
						if(this.languageIndex == 0){
							name = v.name;
						}else{
							name = v.nameEn;
						}

					}
				});
        console.log(this.$route.name);
				window.localStorage.setItem(
					"case",
					JSON.stringify({
						case: this.routePath
					})
				);
				var namePath ='';
				if(id == 600){
          if(this.$route.name == 'mainPaseRegulator') return this.$message.error('暂不支持查看')
          if(this.insti.type == 5){
            namePath='shenhezhongList';
          }else{
            namePath='newstar';
          }
				}
        else if(id == 800 && JSON.parse(window.localStorage.getItem("usertype")).data != 0){
            namePath='Homestart4';
        } else if(id == 900 ){
            namePath='createRescue';
        }
        else{
         if(this.$route.name == 'mainPaseRranch') return this.$message.error('暂不支持查看')
					namePath = this.routePath
				}
        console.log(namePath)
				this.$router.push({
					name:namePath,
					params: {
						token: token,
						insti: insti,
						flag: false
					},
					query: {
						typeId: id,
						name: name
					}
				});
			}
		},
	}
import langtrans from "./js/service.vue.trans.js";
</script>

<style scoped="scoped">
  .act1 {
    border: 1px solid #1890FF;
    color: #1890FF;
    border-radius: 4px 0px 0px 4px;
  }
  .act2 {
    border: 1px solid #1890FF;
    color: #1890FF;
    border-radius: 0px 4px 4px 0px;
  }
  .tab {
      width: 49%;
      height: 25px;
      line-height: 26px;
      text-align: center;
      float: left;
      cursor: pointer;
  }
 .Newli {width: 270px;
    height: 87px;
    text-align: center;
    border: 1px solid #DEE8EF;
    line-height: 87px;
    margin-top: 15px;
    margin-left: 15px;
    float: left;
    border-radius:5px;
    position: relative;
    cursor: pointer;
  }
	.serviceBox{position: relative;}
	.serviceBox .list{padding-top:40px;overflow: hidden;padding-bottom: 10px;}
	.serviceBox .list li{width:150px;border:1px solid #eee;height: 250px;border-radius: 3px;padding: 0 25px;padding-top: 40px;text-align: left;float: left;margin-right: 10px;cursor: pointer;}
	.serviceBox .list li:last-child{margin-right: 0;}
	.serviceBox .list li >img{margin: 0 auto;display: block;margin-bottom: 20px;}
	.serviceBox .list li h3{font-size: 18px;}
  /* white-space: nowrap; */
	.serviceBox .list li p{font-size: 14px;color: #666;margin-top: 20px;line-height: 20px;height: 20px;overflow: hidden;transition:all 0.3s}
	.serviceBox .list li .manage .arrow{height: 30px;width: 30px;background: url('./img/weixuanzhong.png') no-repeat center center;margin: 0 auto;margin-top: 40px;}
	.serviceBox .list li:hover .manage .arrow{background: url('./img/active.png') no-repeat center center;margin-left: 60%;}
	.serviceBox .list li .manage{position: relative;}
	.serviceBox .list li .manage p{position: absolute;top: 0;margin-top: 0;left: 20%;color: #00abfa;display: none;white-space: nowrap;}
	.serviceBox .list li:hover{box-shadow: 4px 8px 10px rgba(0,171,250,0.2);}
	.serviceBox .list li:hover p{height: 60px;}
	.serviceBox .list li:hover .manage{margin-top: 10px;}
	.serviceBox .list li:hover .manage p{display: block;margin-top: 7px;}
	.serviceBox .list li:hover .enlange{margin-top: 10px;}
	.serviceBox .list li:hover .enlange p{display: block;margin-top: 5px;left: -10%;}
	.serviceBox .list li:hover .enlange .arrow{background: url('./img/active.png') no-repeat center center;margin-left: 75%;}
	.serviceBox .zixun{position: absolute;right: -80px;top: 40px;border: 1px solid #eee;padding: 0 30px;height: 250px;width: 20px;background: white;padding-top: 40px;cursor: pointer;}
	.serviceBox .zixun p{width: 20px;font-size: 14px;text-align: center;}
	.serviceBox .zixun .img1{margin-top: 20px;margin-left: -5px;}
	.serviceBox .zixun .img2{margin-top: 65px;}
	.fixed{width: 1200px;overflow-x:auto;}
</style>



// WEBPACK FOOTER //
// src/views/commonPage/service.vue